"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/js/typography/fontFamilies.ts
var fontFamilies = {
  euclidCircularB: "Euclid Circular B"
};



exports.fontFamilies = fontFamilies;
//# sourceMappingURL=chunk-LONLRSC2.js.map